import { RSAA } from 'redux-api-middleware'
import {
  makeQueryParams,
  webStorage,
  getApiPath,
} from 'sidecar-utility-library'

import { initialState, types } from './index'

export const fetchBookmarks = () => ({
  [RSAA]: {
    endpoint: getApiPath(
      `doc`,
      `bookmarks/doctors${makeQueryParams({
        page: 0,
        size: 25,
        memberUuid: webStorage.getItem('sub'),
      })}`,
      'v2',
    ),
    method: 'GET',
    types: [
      types.FETCH_BOOKMARKS_REQUEST,
      types.FETCH_BOOKMARKS_SUCCESS,
      types.FETCH_BOOKMARKS_ERROR,
    ],
  },
})

export const bookmarkDoctor = npi => ({
  [RSAA]: {
    endpoint: getApiPath(
      `doc`,
      `bookmarks${makeQueryParams({
        npi,
        memberUuid: webStorage.getItem('sub'),
      })}`,
      'v2',
    ),
    method: 'POST',
    types: [
      types.BOOKMARK_DOCTOR_REQUEST,
      { type: types.BOOKMARK_DOCTOR_SUCCESS, meta: { npi } },
      types.BOOKMARK_DOCTOR_ERROR,
    ],
  },
})

export const unbookmarkDoctor = npi => ({
  [RSAA]: {
    endpoint: getApiPath(
      `doc`,
      `bookmarks${makeQueryParams({
        npi,
        memberUuid: webStorage.getItem('sub'),
      })}`,
      'v2',
    ),
    method: 'DELETE',
    types: [
      types.UNBOOKMARK_DOCTOR_REQUEST,
      { type: types.UNBOOKMARK_DOCTOR_SUCCESS, meta: { npi } },
      types.UNBOOKMARK_DOCTOR_ERROR,
    ],
  },
})

export default (
  state = initialState,
  { type, payload = {}, meta = {} } = {},
) => {
  switch (type) {
    case types.FETCH_BOOKMARKS_REQUEST: {
      return {
        ...state,
        bookmarks: {
          ...state.bookmarks,
          busy: true,
          error: '',
        },
      }
    }
    case types.FETCH_BOOKMARKS_SUCCESS: {
      const { content = [] } = payload
      return {
        ...state,
        bookmarks: {
          ...state.bookmarks,
          busy: false,
          entities: content,
        },
      }
    }
    case types.FETCH_BOOKMARKS_ERROR: {
      return {
        ...state,
        bookmarks: {
          ...state.bookmarks,
          busy: false,
          error: payload.response.message,
        },
      }
    }

    // ---------

    case types.BOOKMARK_DOCTOR_REQUEST:
    case types.UNBOOKMARK_DOCTOR_REQUEST: {
      return {
        ...state,
        bookmarks: {
          ...state.bookmarks,
          busy: true,
          error: '',
        },
      }
    }
    case types.BOOKMARK_DOCTOR_SUCCESS: {
      return {
        ...state,
        searchResults: {
          ...state.searchResults,
          entities: state?.searchResults?.entities?.map(provider =>
            provider.npi != null && provider.npi === meta.npi
              ? { ...provider, bookmarked: true }
              : provider,
          ),
        },
        bookmarks: {
          ...state.bookmarks,
          entities: [...state.bookmarks.entities, payload],
          busy: false,
        },
        doctorDetails: {
          ...state.doctorDetails,
          details: {
            ...state.doctorDetails.details,
            bookmarked:
              state.doctorDetails.details.npi != null &&
              state.doctorDetails.details.npi === meta.npi
                ? true
                : state.doctorDetails.details.bookmarked,
          },
        },
      }
    }
    case types.BOOKMARK_DOCTOR_ERROR:
    case types.UNBOOKMARK_DOCTOR_ERROR: {
      return {
        ...state,
        bookmarks: {
          ...state.bookmarks,
          busy: false,
          error: payload.response.message,
        },
      }
    }

    // ----------

    case types.UNBOOKMARK_DOCTOR_SUCCESS: {
      return {
        ...state,
        searchResults: {
          ...state.searchResults,
          entities: state?.searchResults?.entities?.map(provider =>
            provider.npi != null && provider.npi === meta.npi
              ? { ...provider, bookmarked: false }
              : provider,
          ),
        },
        bookmarks: {
          ...state.bookmarks,
          entities: state.bookmarks.entities.filter(
            doctor => doctor.npi == null || doctor.npi !== meta.npi,
          ),
          busy: false,
        },
        doctorDetails: {
          ...state.doctorDetails,
          details: {
            ...state.doctorDetails.details,
            bookmarked:
              state.doctorDetails.details.npi != null &&
              state.doctorDetails.details.npi === meta.npi
                ? false
                : state.doctorDetails.details.bookmarked,
          },
        },
      }
    }
    // ----------

    default:
      return state
  }
}
